import './index.less';
import { ITouchKitEventCallback, TouchKit, TouchKitEventType } from '@/utils/event-kit';
import { IExportPlugin, PluginType } from '@/version-types';
import { InstanceData, InstanceDataType } from '../data';
import { Operate } from './instance';
import editorOperateState, { getEditorOperateState } from './states/editor-operate-state';
import layerOperateState from './states/layer-operate-state';
import { MoveListenerLevel } from './type';

export * from './type';
export * from './hooks';
export * from './views/base-operate-view';
export * from './views/base-stage-plugin';
export * from './views/base-viewport-plugin';
export * from './views/base-system-plugin';
export * from './views/stage-scale-view';
export * from './views/drag-and-drop-layer';
export * from './hotkey';
export * from './listener';

export const frameworkOperatePlugin: IExportPlugin = {
    sort: 0,
    type: PluginType.EXTENSION,
    name: 'framework-operate',
    createState() {
        return [editorOperateState, layerOperateState];
    },
};

export function createOperate(identity: string) {
    const operate = new Operate(identity);
    InstanceData.setData(identity, InstanceDataType.Operate, operate);

    const tk = new TouchKit();
    InstanceData.setData(identity, InstanceDataType.TouchListenerList, []);

    tk.on(TouchKitEventType.Move, (e) => {
        if (getEditorOperateState(identity).disableOperate) return;
        const tkListenerList = InstanceData.getData(identity, InstanceDataType.TouchListenerList) as {
            name: string;
            level: MoveListenerLevel;
            listenerRef: { current: ITouchKitEventCallback };
        }[];
        const listenerList = tkListenerList.sort((a, b) => b.level - a.level).map((item) => item.listenerRef.current);
        listenerList.forEach((listener) => {
            listener(e);
        });
    });

    InstanceData.setData(identity, InstanceDataType.TouchData, tk);

    InstanceData.onDestroy(identity, (identity) => {
        const tk = InstanceData.getData(identity, InstanceDataType.TouchData) as TouchKit;
        if (tk) {
            tk.off(TouchKitEventType.Move);
        }
    });

    return operate;
}

export function OperateAPI(identity: string) {
    return InstanceData.getData(identity, InstanceDataType.Operate) as Operate;
}

export type IOperate = ReturnType<typeof OperateAPI>;
